import { render, staticRenderFns } from "./ComponentAudit.vue?vue&type=template&id=b263b0fc&scoped=true&"
import script from "./ComponentAudit.vue?vue&type=script&lang=js&"
export * from "./ComponentAudit.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAudit.vue?vue&type=style&index=0&id=b263b0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b263b0fc",
  null
  
)

export default component.exports